import React from "react";
import {AsposeFooter, AsposeHeader} from "./src/components/AsposeMenu";

// Wraps every page in the aspose.ai header and footer. Shared by gatsby-browser.js and
// gatsby-ssr.js so the menu is part of the pre-rendered HTML, not something that has to
// be fetched from menucdn.containerize.com after the page loads.
//
// Comment out either line below to drop that piece; the matching stylesheet import lives
// in gatsby-browser.js.
//
// This wrapper runs outside gatsby-plugin-react-i18next's (the site's wrapPageElement wraps the
// plugins'), so the header gets the page's language from pageContext rather than from i18next.
export const wrapPageElement = ({element, props}) => (
    <>
        <AsposeHeader i18n={props?.pageContext?.i18n}/>
        {element}
        <AsposeFooter/>
    </>
);
